export const ROLE_LIST_PERMISSION = 'roles:list';
export const ROLE_CREATE_PERMISSION = 'roles:create';
export const ROLE_UPDATE_PERMISSION = 'roles:update';
export const ROLE_ASSIGN_PERMISSION = 'roles:assign';
export const ROLE_DELETE_PERMISSION = 'roles:delete';

export const PERMISSION_DELETE_PERMISSION = 'permissions:delete';

export function canViewRoleUsers(hasPermission: (code: string) => boolean): boolean {
  return hasPermission(ROLE_LIST_PERMISSION);
}

export function canOpenRolePermissionDrawer(hasPermission: (code: string) => boolean): boolean {
  return hasPermission(ROLE_ASSIGN_PERMISSION) && hasPermission('permissions:list');
}

export function canSaveRolePermissions(
  hasPermission: (code: string) => boolean,
  catalogLoaded: boolean
): boolean {
  return canOpenRolePermissionDrawer(hasPermission) && catalogLoaded;
}

export function roleUsersAfterFetch<T>(
  ok: boolean,
  payload?: T[] | unknown
): { users: T[]; failed: boolean } {
  if (!ok) {
    return { users: [], failed: true };
  }
  return { users: Array.isArray(payload) ? (payload as T[]) : [], failed: false };
}

export function roleUsersTableEmptyText(failed: boolean): string {
  return failed ? '加载失败，请重试' : '暂无关联用户';
}
